import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { User, onAuthStateChanged } from 'firebase/auth'
import { auth } from '../firebase'

export const useAuthWatcher = () => {
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
        setIsLoading(false)
      } else {
        navigate('/login')
      }
    })

    return () => unsubscribe()
  }, [navigate])

  return { user, isLoading }
}
